import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Expenses from './pages/Expenses';
import Investments from './pages/Investments';
import Stocks from './pages/Stocks';
import Crypto from './pages/Crypto';
import OtherInvestments from './pages/OtherInvestments';
import Properties from './pages/Properties';
import Income from './pages/Income';
import Commissions from './pages/Commissions';
import RecurringBills from './pages/RecurringBills';
import Agent from './pages/Agent';
import Analysis from './pages/Analysis';
import ProjectAnalysis from './pages/ProjectAnalysis';
import ShareView from './pages/ShareView';
import Notes from './pages/Notes';
import Assistant from './pages/Assistant';
function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const handleLogin = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };
  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };
  return (
    <Router>
      <Routes>
        {/* Public client-facing share page — no login required */}
        <Route path="/share/analysis/:token" element={<ShareView />} />
        <Route path="/login" element={token ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
        <Route path="/" element={token ? <Dashboard token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/expenses" element={token ? <Expenses token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/investments" element={token ? <Investments token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/investments/stocks" element={token ? <Stocks token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/investments/crypto" element={token ? <Crypto token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/investments/other" element={token ? <OtherInvestments token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/properties" element={token ? <Properties token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/income" element={token ? <Income token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/commissions" element={token ? <Commissions token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/recurring-bills" element={token ? <RecurringBills token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/agent" element={token ? <Agent token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/notes" element={token ? <Notes token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/assistant" element={token ? <Assistant token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/analysis" element={token ? <Analysis token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/project-analysis" element={token ? <ProjectAnalysis token={token} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
export default App;
